var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.message)+"\n  ")]),_vm._v(" "),_c('LoaderIcon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }